var _rect, _rect2, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPulseActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4074,
    y: -6590,
    width: 11584,
    height: 15424,
    fill: "#5D5CF5",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -352H228V548H-28V-352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -352H228V548H-28V-352Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-28 -14H228V16V46H-28V-14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-22 -8C-22 -12.4183 -18.4183 -16 -14 -16H209C213.418 -16 217 -12.4183 217 -8V8.37548C217 9.7677 217.363 11.1358 218.054 12.3446L220.716 17.0039C220.892 17.3113 220.892 17.6887 220.716 17.9961L218.054 22.6554C217.363 23.8642 217 25.2323 217 26.6245V40C217 44.4183 213.418 48 209 48H-14C-18.4183 48 -22 44.4183 -22 40V-8Z",
    fill: "#5D5CF5",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5E61EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15C13.167 15 12.854 14.834 12.668 14.555L10.965 12.0001H9C8.448 12.0001 8 11.5521 8 11.0002C8 10.4482 8.448 10.0002 9 10.0002H11.5C11.834 10.0002 12.146 10.1672 12.332 10.4452L13.376 12.0111L15.605 7.5523C15.769 7.22631 16.096 7.01432 16.461 7.00032C16.849 6.99132 17.169 7.17231 17.357 7.4843L20.066 12.0001H22C22.552 12.0001 23 12.4481 23 13.0001C23 13.5521 22.552 14 22 14H19.5C19.149 14 18.823 13.816 18.643 13.5151L16.58 10.0772L14.395 14.448C14.235 14.767 13.918 14.977 13.562 14.999C13.542 15 13.521 15 13.5 15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4434 17.003L18.0716 16.6092V14.0332C18.0716 13.4743 17.5883 13.0212 16.9921 13.0212C16.396 13.0212 15.9127 13.4743 15.9127 14.0332V19.0315L14.8913 18.2281C14.4356 17.8695 13.7184 17.8989 13.2977 18.2933C12.877 18.6877 12.9057 19.3037 13.3615 19.6623L15.9127 21.6692C15.9127 21.9402 16.1323 22.1599 16.4033 22.1599H21.8894C22.1655 22.1599 22.3894 21.936 22.3894 21.6599C22.3894 19.9941 22.3894 18.0438 22.3894 18.0073C22.3894 17.4967 21.9838 17.0662 21.4434 17.003Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9141 23.5001C15.9141 23.7762 16.1379 24.0001 16.4141 24.0001H21.8908C22.167 24.0001 22.3908 23.7762 22.3908 23.5001C22.3908 23.3776 22.3908 23.2362 22.3908 23.0801H15.9141V23.5001Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPulseActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pulse-active.66f04237.svg";
export { ForwardRef as ReactComponent };